import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

// Component 
import Link from '../../Link';

import history from '../../../core/history';
// Locale
import messages from '../../../locale/messages';

import bt from '../../../components/commonStyle.css';
import s from './SideMenu.css';

const SideMenu = () => {
  const [location, setLocation] = useState('');

  useEffect(() => {
    if (history.location) {
      setLocation(history.location.pathname);
    }
  }, [history.location]);

  return (
    <div>
      <ul className={cx('sideMenuBorder')}>
        <li className={cx('sideMenuBorderPadding', { ['menuActive']: location === "/rooms" })}>
          <Link to={'/rooms'} className={cx('sideNavitem', 'sideNav')}>
            <FormattedMessage {...messages.yourListings} />
          </Link>
        </li>
        <li className={cx('sideMenuBorderPadding', { ['menuActive']: location === "/reservation/current" })}
          onClick={() => setLocation(history.location.pathname)}
        >
          <Link to={'/reservation/current'} className={cx('sideNavitem', 'sideNav')}>
            <FormattedMessage {...messages.upcomingReservations} />
          </Link>
        </li>
        <li className={cx('sideMenuBorderPadding', { ['menuActive']: location === "/reservation/previous" })}
          onClick={() => setLocation(history.location.pathname)}
        >
          <Link to={'/reservation/previous'} className={cx('sideNavitem', 'sideNav')}>
            <FormattedMessage {...messages.previousReservations} />
          </Link>
        </li>
      </ul>
    </div>
  );
}

export default withStyles(s, bt)(SideMenu);